import { getRouteApi, useNavigate } from "@tanstack/react-router";
import { FacilityDetailDrawerContent } from "./FacilityDetailDrawer/FacilityDetailDrawerContent";

const appRouteApi = getRouteApi("/_app");

function closeFacilityDrawer(navigate: ReturnType<typeof useNavigate>) {
  navigate({
    to: ".",
    resetScroll: false,
    search: (prev) => {
      const next = { ...(prev as Record<string, unknown>) };
      delete next.facilityId;
      delete next.tab;
      return next;
    },
  });
}

export function FacilityDetailDrawer() {
  const navigate = useNavigate();
  const search = appRouteApi.useSearch();
  const facilityId = search.facilityId;
  const externalCustomerId = search.externalCustomerId;

  const onClose = () => closeFacilityDrawer(navigate);

  const isDrawerOpen =
    facilityId !== null &&
    facilityId !== undefined &&
    Number.isFinite(facilityId) &&
    facilityId > 0 &&
    !!externalCustomerId;

  if (!isDrawerOpen) {
    return null;
  }

  return (
    <FacilityDetailDrawerContent
      key={`${externalCustomerId}:${facilityId}`}
      facilityId={facilityId}
      externalCustomerId={externalCustomerId}
      onClose={onClose}
    />
  );
}
